<template>
  <div class="container uk-margin-remove">
    <section class="sub-container ">
      <h3 class="title">
        Incoterm Preferido
      </h3>
      <p class="subtitle helper">
        INSTRUCCIONES: Selecione INCOTERM a usar para el envío
      </p>

      <form class="uk-form-stacked">
        <div
          v-for="data in incoterms"
          :key="data.value.id"
          class="uk-margin uk-flex"
          @mouseover="setMessageInformation(`Seleccione ${data.text}`)"
          @mouseleave="setMessageInformation()"
        >
          <label
            style="cursor: pointer;"
            :for="data.value.id"
          >
            <input
              :id="data.value.id"
              v-model="currentIncoterm"
              type="radio"
              name="currentIncoterm"
              class="uk-radio"
              :value="data.value"
            >  {{ data.text }}
          </label>
        </div>
        <div
          v-if="incotermsOptional.length !== 0"
          class="uk-margin uk-column-1-3"
          @mouseover="setMessageInformation('Seleccione otros Incoterm')"
          @mouseleave="setMessageInformation()"
        >
          <div class="uk-form-controls">
            <select
              id="optional"
              v-model="currentIncoterm"
              name="currentIncoterm"
              class="uk-select"
            >
              <option
                v-for="incoterm in incotermsOptional"
                :key="incoterm.value.id"
                :value="incoterm.value"
              >
                {{ incoterm.text }}
              </option>
            </select>
            <label
              class="uk-form-label uk-flex"
              for="optional"
            ><strong>OTRO</strong>
            </label>
          </div>
        </div>
      </form>
    </section>
    <wizard-button :data="selectedIncoterm" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { directionTypeEnum, incotermsEnum } from '../../../../types'
import WizardButton from '../WizardButton.vue'

export default {
  components: {
    WizardButton
  },
  data () {
    return {
      informationMsg: {
        image: null,
        message: null
      },
      directionTypeEnum,
      incotermsEnum,

      currentIncoterm: null
    }
  },
  computed: {
    ...mapGetters([
      'journeyDirection',
      'incoterm',
      'transportMode'
    ]),
    incoterms: function () {
      let incoterm

      if (this.directionTypeEnum.import === this.journeyDirection) {
        incoterm = this.incotermsEnum.filter(inco => inco.isImport === true && inco.isOptional === false).filter(operation => operation.value.operationMode === null || operation.value.operationMode === this.transportMode)
      } else if (this.directionTypeEnum.export === this.journeyDirection) {
        incoterm = this.incotermsEnum.filter(inco => inco.isImport === false && inco.isOptional === false).filter(operation => operation.value.operationMode === null || operation.value.operationMode === this.transportMode)
      }
      return incoterm
    },
    incotermsOptional: function () {
      let incOptional

      if (this.directionTypeEnum.import === this.journeyDirection) {
        incOptional = this.incotermsEnum.filter(inco => inco.isImport === true && inco.isOptional === true)
      } else if (this.directionTypeEnum.export === this.journeyDirection) {
        incOptional = this.incotermsEnum.filter(inco => inco.isImport === false && inco.isOptional === true)
      }
      return incOptional
    },
    selectedIncoterm: function () {
      return {
        incoterm: this.currentIncoterm
      }
    }
  },
  watch: {
    currentIncoterm: {
      handler: function (newVal, oldVal) {
        this.$store.commit('setIncoterm', newVal)
        if (newVal !== oldVal && oldVal !== null) {
          this.resetAll()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.currentIncoterm = this.incoterm !== null ? { ...this.incoterm } : null
  },
  methods: {
    ...mapMutations([
      'setResetInsuranceAndExtras',
      'setResetShippingLogistic',
      'setResetShippingLogisticAirportManagement',
      'setResetReceptionLogistics',
      'setResetReceptionLogisticsAirportManagement',
      'setResetInsuranceAndExtras',
      'setResetAdministrationFees',
      'setResetProceduresAndPermits',
      'setResetTaxesAndFees',
      'setResetTerminalManagement',
      'setResetAirportManagement',
      'setResetInternationalTransport',
      'resetComponentSelectionStore',
      'setResetShippingFeatures',
      'setResetPathCharacteristics',
      'resetWizardStore'

    ]),
    setMessageInformation (message, image) {
      this.informationMsg.image = image
      this.informationMsg.message = message

      this.$store.commit('setMessageInformation', this.informationMsg)
    },
    resetAll () {
      this.setResetInsuranceAndExtras()
      this.setResetShippingLogistic()
      this.setResetShippingLogisticAirportManagement()
      this.setResetReceptionLogistics()
      this.setResetReceptionLogisticsAirportManagement()
      this.setResetInsuranceAndExtras()
      this.setResetAdministrationFees()
      this.setResetProceduresAndPermits()
      this.setResetTaxesAndFees()
      this.setResetTerminalManagement()
      this.setResetAirportManagement()
      this.setResetInternationalTransport()
      this.resetComponentSelectionStore()
      this.setResetShippingFeatures()
      this.setResetPathCharacteristics()
      this.resetWizardStore(true)
    }
  }
}
</script>

<style scoped>
.container{
  width: 100%;

}

.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
.title{
  font-weight: 600;
  margin-bottom: 10px;

}
.sub-container{
  width: 100%;
  min-height: 418px;
  padding: 16px 41px;
}
.helper{
  color:rgb(119 118 118 / 58%) !important;
  margin: 5px 0px
}
.uk-form-stacked{
  margin-top: 18px;
}
@media screen and (max-width: 879px){
.sub-container{
    padding: 10px 20px;
  }
}
@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

}

@media screen and (max-width: 600px){
  *{
    font-size: 10px;
  }
 .subtitle{
    margin: 2px;
    font-size: 10px;
  }
  .uk-form-stacked{
    margin-top: 10px;
}
}
</style>
